
import NavBarButton from './NavBarButton.vue'

export default {
  name: 'NavBar',
  components: {
    NavBarButton,
  },
  props: {
    isOpened: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      subCategoriesSimulated: false,
      navBarLinks: [
        { name: 'Home', link: '/', icon: 'fa-solid fa-house', exact: true },
        {
          name: 'Turmas',
          link: '',
          icon: 'fa-solid fa-users',
          modalTurmas: true,
        },
        {
          name: 'Mural de recados',
          link: '/messagewall',
          icon: 'fa-solid fa-comments',
        },
        {
          name: 'Materiais',
          link: '/materials',
          icon: 'fa-solid fa-file',
        },
        {
          name: 'Videoaulas',
          link: '/videos',
          icon: 'fa-solid fa-video',
        },
        {
          name: 'Simulados',
          active: '/simulados',
          icon: 'fa-solid fa-file-lines',
          class: 'h-24',
          childLinks: [
            {
              name: 'Para resolução',
              link: '/simulados',
              exact: true,
              icon: 'fa-solid fa-list',
            },
            {
              name: 'Respondidos',
              link: '/simulados/simulatedResult',
              icon: 'fa-solid fa-check',
            },
            // {
            //   name: 'Ranking de notas',
            //   link: '#',
            //   icon: 'fa-solid fa-trophy',
            // },
            // {
            //   name: 'Estatiscas',
            //   link: '/simulados/myResults',
            //   icon: 'fa-solid fa-circle',
            // },
          ],
        },
        {
          name: 'Provas (2a fase)',
          active: '/exam',
          class: 'h-24',
          icon: 'fa-solid fa-file-pen',
          childLinks: [
            {
              name: 'Para resolução',
              link: '/exam/exams',
              icon: 'fa-solid fa-pencil',
            },
            {
              name: 'Correções',
              link: '/exam/correction',
              icon: 'fa-solid fa-person-chalkboard',
            },
            // {
            //   name: 'Ranking de notas',
            //   link: '#',
            //   icon: 'fa-solid fa-trophy',
            // },
          ],
        },
        {
          name: 'Caderno de Erros',
          link: '/errorsBook',
          icon: 'fa-solid fa-book',
        },
      ],
      links: {
        name: 'Suporte ao aluno',
        link: '/suport',
        icon: 'fa-solid fa-phone',
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters['credential/user']
    },
  },
  mounted() {
    this.getIA()
  },
  methods: {
    closeHeader(modal) {
      if (modal) {
        this.$store.commit('modal/toggleClassModal')
      }
      if (window.innerWidth <= 640) {
        this.$store.commit('navbar/closeNavBar')
      }
    },
    toggleNavBar() {
      this.$store.commit('navbar/toggleNavBar')
    },
    getIA() {
      if (localStorage.serviceType === 'OPEN IA') {
        this.navBarLinks.push({
          name: 'Mege IA',
          link: '/IA',
          icon: 'fa-solid fa-user-robot',
        })
      }
    },
  },
}
